import {CollectionFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient, CompanyFinancingView} from '@modifi/onboarding-api-clients'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = CollectionFactory({
  actionNamePrefix: 'data/financing-options/collection',
  reducerPath: ['data', 'financingOptions', 'collection'],
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  entityPrimaryKeySelector: (entity: CompanyFinancingView) => entity.externalId!,
  fetchRequest: () =>
    apiClient.CompanyFinancings.fetch({}).then(res => res.data()?.companyFinancings || []),
})

export default reducer as Reducer

export const selectFinancingOptions = (state: Record<string, any>): CompanyFinancingView[] =>
  selectors.selectByKeyWindow(state, 'all')

export const selectFinancingOptionsWhereLoaded = (state: Record<string, any>): boolean =>
  selectors.selectFetchCountByKeyWindow(state, 'all') > 0

export const aFetchFinancingOptions = (): any => actions?.fetch('all')

const aUpdateLocalFinancingOption = (entity: CompanyFinancingView, merge = true): any =>
  actions?.update(entity, merge)

export const aUpdateLocalFinancingOptionSellerBankAccount = (
  externalFinancingConfigId: string,
  sellerBankAccount: NonNullable<CompanyFinancingView['sellerBankAccount']>
): any =>
  aUpdateLocalFinancingOption({
    externalId: externalFinancingConfigId,
    sellerBankAccount,
  })

export const aRemoveSellerBankAccountFromLocalFinancingOption = (
  externalFinancingConfigId: string
): any =>
  aUpdateLocalFinancingOption({externalId: externalFinancingConfigId, sellerBankAccount: undefined})
